<div>
  <span class="font-app-bold text-darkest text-sm md:text-base">
    {{ "contract.informations" | translate }}
  </span>
</div>

<div
  *ngIf="getIsVisible(policyFieldsVM, PolicyFields.DECLARATION, Declaration.ID_ANI)"
  class="flex flex-col sm:flex-row items-start sm:items-center w-full pl-2">
  <div class="flex items-center w-full sm:w-1/2 p-1 mb-2 sm:mb-0">
    <span class="font-app-regular text-dark text-sm md:text-base">
      {{ "SA_KEYS.ID_ANI" | translate }}
    </span>
  </div>

  <div class="flex items-center w-full sm:w-1/2 p-1">
    <div class="w-full sm:w-2/3 ml-0 sm:ml-auto">
      <input
        [disabled]="
          !getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, Declaration.ID_ANI, hasEndorsementWait4Sign)
        "
        pInputText
        type="text"
        [ngClass]="
          getInputClass(
            contractFormGroup.controls.identificationNumber.dirty,
            getIsEditable(policyFieldsVM, PolicyFields.DECLARATION, Declaration.ID_ANI, hasEndorsementWait4Sign)
          ) +
          ' w-full' +
          (contractFormGroup.controls.identificationNumber.invalid ? ' ng-invalid ng-dirty' : '')
        "
        [placeholder]="'generalOptions.placeholder' | translate"
        [formControl]="contractFormGroup.controls.identificationNumber" />
    </div>
  </div>
</div>
